import React from "react";
// import { NavLink } from 'react-router-dom'
import logo from "../../../assets/images/commonImg/header_logo.png";
import "../../../assets/styles/common/header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";


const Header = () => {


  return (
    <>
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className="bg-white "
        >
          <Container fluid>
            <Navbar.Brand>
              <Link to="/">
                <img src={logo} alt="oxyzn" className="logo-header" />
              </Link>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <div>
                    <img src={logo} alt="oxyzn" />
                  </div>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="align-items-center">
                <Nav className="justify-content-center flex-grow-1 ">
                  <Nav.Link className="nav-items " as={Link} to="/">
                    For Businesses
                  </Nav.Link>
                  <Nav.Link className="nav-items" as={Link} to="/pricing">
                    Pricing plans
                  </Nav.Link>
                  <Nav.Link className="nav-items" as={Link} to="/team">
                    Team
                  </Nav.Link>
                  <Nav.Link className="nav-items" as={Link} to="/">
                    About
                  </Nav.Link>
                </Nav>
                <div className="justify-content-end d-flex">
                  <Nav.Link className="nav-items" as={Link} to="https://oxyzn.infograins.com/portal/" target="_blank">
                    Login
                  </Nav.Link>
                  {/* <Nav.Link className="demo_button" as={Link} to="/contact">
                    Request a demo
                  </Nav.Link> */}
                  {/* <Nav.Link className="demo_button" as={Link} to="https://calendly.com/oxyzn/meeting-with-oxyzn" target="_blank">
                    Request a demo
                  </Nav.Link> */}
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default Header;